import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import { format } from 'date-fns'
import moment from 'moment-timezone'

import { Paper, Button } from 'components'
import { ItemModal } from 'features'
import { FaTimes } from 'react-icons/fa'

import * as actionCreators from 'store/actions'
import * as dates from 'react-big-calendar/lib/utils/dates'
import { itemContext } from 'context'

const Container = styled.div`
    border-radius: 5px;
    background-color: ${props => props.styles.primaryColor};
    padding: 0.5rem 0.5rem;
    width: 10rem;
`

const ItemTile = styled.div`
    border-radius: 5px;
    margin-bottom: 1px;
    font-size: 0.8rem;
    padding: 0.1rem 0 0.2rem 0.2rem;
    background-color: ${props => props.styles.secondaryColor};
    /* border-top: 1px solid var(--secondary-accent-color);
    border-right: 1px solid var(--secondary-accent-color);
    border-bottom: 1px solid var(--secondary-accent-color); */
    opacity: ${props => props.completed ? 0.5 : 1};
    border-left: ${props => props.color ? `5px solid ${props.color}` : '5px solid var(--secondary-accent-color)'};
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 2rem 1fr 2rem;
    margin-bottom: 0.5rem;
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const Title = styled.div`
    font-size: 1.2rem;
    text-transform: uppercase;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
`

class DayModal extends Component {
    constructor(props){
        super(props);
        const defaultStyles = {
            primaryColor: 'var(--primary-color)',
            secondaryColor: 'var(--secondary-color)',
        }
        const updatedStyle = Object.assign({}, defaultStyles, this.props.styles)
        this.updatedStyle = updatedStyle
    }

    getTitle = (event) => {
        const timezone = this.props.user['timezone']
        let end = event.end
        let start = event.start
        let allDay = event.allDay
        let showAsAllDay = allDay || dates.diff(start, dates.ceil(end, 'day'), 'day') > 1
        const startTime = moment(event.start).tz(timezone).format('h:mma')

        let title = event.allDay ? event.title 
                    : showAsAllDay ? event.title
                    : `${startTime.toLowerCase()} ${event.title}`
        return title
    }

    getBlocks = () => {
        let blocks = []
        const events = _.sortBy(this.props.events, 'start')
        Object.values(events).map(event => {
            const item = event['item']
            const text = this.getTitle(event)
            // const text = item.getPlainText()
            blocks.push(
                <ItemTile onClick={() => this.props.setModal(<ItemModal itemID={item['itemID']}/>, `${item['itemID']}_ItemModal`)} styles={this.updatedStyle} 
                    completed={item['status'] === itemContext.STATUS.COMPLETED}>
                    {text}
                </ItemTile>
            )
        })
        return blocks
    }
    

    render(){
        const blocks = this.getBlocks()
        return (
            <Paper>
                <Container styles={this.updatedStyle}>
                    <Wrapper>
                        <div/>
                        <TitleContainer>
                            <Subtitle>{format(this.props.date, 'eee')}</Subtitle>
                            <Title>{format(this.props.date, 'd')}</Title>
                        </TitleContainer>
                        <div style={{justifySelf: 'flex-end'}}><Button icon={<FaTimes/>} onSelect={() => this.props.setPopOut(null)} styles={{margin: 0, padding: '0.2rem', width: '1rem', height: '1rem', backgroundColor: this.updatedStyle['primaryColor'], boxShadowColor: 'transparent'}}/></div>
                    </Wrapper>
                    {blocks}
                </Container>
            </Paper>
        )
    }
}

const mapStateToProps = state => {
    return {
        data: state.db.present.data && state.db.present.data.toJS(),
        modalID: state.content.modalID,
        user: state.auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DayModal);